import React from "react";
import { useState } from "react";
import DatePicker from "react-datepicker";
import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import "react-datepicker/dist/react-datepicker.css";
import { launchParameters } from "../../../services/user.service";
import Button from "../../../components/button";
import styles from "./styles.module.css";

registerLocale("es", es);

function RunParametes() {
  const [startDate, setStartDate] = useState(new Date());
  const [sentParam, setSentParam] = useState("");

  const handleDate = (date) => {
    setStartDate(date);
  };

  const handleClick = (parmode, nicename) => {
    launchParameters(startDate, [parmode])
      .then((response) => {
        setSentParam(
          `Cálculo de párametros para ${nicename} finalizado a las ${response.data.time}. Estado final: ${response.data.state === "failed" ? "error" : "éxito"}.`
        );
      })
      .catch((error) => {
        console.log(error);
      });
    setSentParam(
      `Petición de cálculo de parámetros para ${nicename} enviada a las \n ${new Date().toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false })}.`
    );
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h3 className={styles.title}>Calcular Parámetros</h3>
      </div>
      <DatePicker
        locale="es"
        portalId="root-portal"
        dateFormat="dd/MM/yyyy"
        selected={startDate}
        onChange={handleDate}
        popperClassName="date-picker-reports"
        className={styles.datePicker}
      />

      <Button
        variant="primary"
        title="Calcula parámetros"
        onClick={() => handleClick("lastprice", "Precio Último")}
      >
        Precio Último
      </Button>
      <div
        className={`${styles.statusMessage} ${sentParam ? styles.statusMessageActive : ""}`}
      >
        {sentParam}
      </div>
    </div>
  );
}

export default RunParametes;
